/**
 * Simple cart store using localStorage + custom events
 * so Header and SeatSelectionPage share real-time cart data.
 */

const CART_KEY = 'maseventos_cart';
const CART_EVENT = 'maseventos:cart-updated';
export const CART_CLEARED_EVENT = 'maseventos:cart-cleared';

export function getCart() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || [];
  } catch { return []; }
}

export function setCart(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent(CART_EVENT));
}

export function clearCart() {
  localStorage.removeItem(CART_KEY);
  window.dispatchEvent(new CustomEvent(CART_EVENT));
  window.dispatchEvent(new CustomEvent(CART_CLEARED_EVENT));
}

export const SEAT_REMOVED_EVENT = 'maseventos:seat-removed';

export function removeSeat(seatId) {
  const cart = getCart();
  const updated = cart.map(item => {
    const newSeats = (item.seats || []).filter(s => s.id !== seatId);
    if (newSeats.length === 0) return null; // remove entire item if no seats left
    const newTotal = newSeats.reduce((sum, s) => sum + (Number(s.price) || 0), 0);
    return {
      ...item,
      seats: newSeats,
      cantidad: newSeats.length,
      total: newTotal,
      subtotal: newTotal,
    };
  }).filter(Boolean);

  if (updated.length === 0) {
    clearCart();
  } else {
    setCart(updated);
  }
  window.dispatchEvent(new CustomEvent(SEAT_REMOVED_EVENT, { detail: { seatId } }));
}

/**
 * React hook — re-renders on cart changes.
 */
import { useState, useEffect } from 'react';

export function useCart() {
  const [items, setItems] = useState(getCart);

  useEffect(() => {
    const handler = () => setItems(getCart());
    window.addEventListener(CART_EVENT, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(CART_EVENT, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  return items;
}
